import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import {validateForm, blurValidations} from './Common/formValidator';

class LoginPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: "",
            oldUsername: "",
            oldPassword: ""
        };
    }
    componentDidMount(){
        blurValidations($(findDOMNode(this.refs.loginHolder)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }
    handleLogin = (e) => {
        if(this.state.username!==""&&this.state.password!==""&&this.state.oldUsername===this.state.username&&this.state.oldPassword===this.state.password)
            return;

        if(validateForm($(findDOMNode(this.refs.loginHolder)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false })){
            this.props.doLogin(this.state.username, this.state.password);
            this.setState({oldUsername: this.state.username, oldPassword: this.state.password});
        }
    }
    handleKeyDown = (event) => {
        if(event.charCode === 13){
            this.handleLogin();
        }
    }
    updateUsername = (e) => {
        this.setState({username: e.target.value});
    }
    updatePassword = (e) => {
        this.setState({password: e.target.value});
    }
    render() {
        const loginMsg = this.props.errorMessage==="" ? "" : <p id="loginMsg">{this.props.errorMessage}</p>
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : "";

        return (
            <div id="loginHolder" ref="loginHolder" className={"contentHolder form" + loadingClass}>
                {loginMsg}
                <h2>Login</h2>
                <div className="fieldHolder required">
                    <TextField fullWidth={true}
                               id="loginUsername"
                               onChange={this.updateUsername}
                               label="Nome de Utilizador"
                               placeholder="Introduza o seu nome de Utilizador"
                               onKeyPress={this.handleKeyDown}
                               data-empty-error="Este campo não pode estar vazio" />
                </div>
                <div className="fieldHolder required">
                    <TextField fullWidth={true}
                               id="loginPassword"
                               onChange={this.updatePassword}
                               label="Password"
                               placeholder="Introduza a sua Password"
                               data-empty-error="Este campo não pode estar vazio"
                               onKeyPress={this.handleKeyDown}
                               type="password" />
                </div>
                <div className="buttonsHolder">
                    <Button variant="contained" color="secondary">Cancelar</Button>
                    <Button onClick={this.handleLogin} className="float-right" onKeyPress={this.handleKeyDown} variant="contained" color="primary">Entrar</Button>
                    <Link to="Schedules">Forgot Password?</Link>
                </div>
            </div>
        );
    }
}

export default LoginPanel;
